import React from 'react';
import ScheduleCalendar from '../components/ScheduleCalendar';

const SchedulePage: React.FC = () => {
  return <ScheduleCalendar />;
};

export default SchedulePage;